import { rootApi } from 'root-api'

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    fetchJoinableOrganizations: build.query({
      query: () => ({ url: '/api/organization/join/joinable_organizations' })
    }),
    getOrganizationInvitation: build.query({
      query: ({ id }) => ({ url: `/api/organization/join/organization_invitations/${id}` }),
      extraOptions: {
        handleErrors: false
      }
    }),
    setActivationDataForJoinOrgBanner: build.mutation({
      query: ({ id }) => () => ({
        url: `/api/users/${id}/activation_data`,
        method: 'patch',
        data: {
          activation_data: {
            has_closed_join_an_org_banner: true
          }
        }
      }),
      invalidatesTags: ['CURRENT_USER']
    }),
    upsertOrganizationInvitation: build.mutation({
      query: (organizationId) => ({
        url: `/api/organization/join/joinable_organizations/${organizationId}/organization_invitation`,
        method: 'post'
      })
    }),
    declineRequestToJoinOrganization: build.mutation({
      query: ({ id, message }) => ({
        url: `/api/organization/join/organization_invitations/${id}/decline`,
        method: 'put',
        data: { message }
      })
    })
  })
})

export const {
  useFetchJoinableOrganizationsQuery,
  useSetActivationDataForJoinOrgBannerMutation,
  useUpsertOrganizationInvitationMutation,
  useDeclineRequestToJoinOrganizationMutation,
  useGetOrganizationInvitationQuery
} = api
